const ScaleIcon = ({ width, height }) => {
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.50003 7.25C5.78403 7.25 6.04403 7.41099 6.17103 7.66499L8.52103 12.365C8.89503 12.472 9.22605 12.681 9.47205 13.063C9.72105 13.45 9.80302 13.847 9.71702 14.276C9.65202 14.601 9.48703 14.932 9.34402 15.218C9.34002 15.2265 9.33578 15.235 9.33152 15.2435C9.32727 15.252 9.32302 15.2605 9.31903 15.269C8.59802 16.717 7.18003 17.75 5.50003 17.75C3.82003 17.75 2.40204 16.717 1.68104 15.269C1.67704 15.2605 1.67279 15.252 1.66854 15.2435C1.66429 15.235 1.66004 15.2265 1.65604 15.218C1.51304 14.932 1.34804 14.601 1.28304 14.276C1.19704 13.847 1.27901 13.45 1.52801 13.063C1.77401 12.681 2.10504 12.472 2.47904 12.365L4.82904 7.66499C4.95604 7.41099 5.21603 7.25 5.50003 7.25ZM5.50003 9.677L6.78704 12.25H4.21405L5.50003 9.677Z"
          fill="#0051FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.5 7.25C18.784 7.25 19.044 7.41099 19.171 7.66499L21.521 12.365C21.895 12.472 22.2261 12.681 22.4721 13.063C22.7211 13.45 22.803 13.847 22.717 14.276C22.652 14.601 22.487 14.932 22.344 15.218C22.34 15.2265 22.3358 15.235 22.3315 15.2435C22.3273 15.252 22.323 15.2605 22.319 15.269C21.598 16.717 20.18 17.75 18.5 17.75C16.82 17.75 15.402 16.717 14.681 15.269C14.677 15.2605 14.6728 15.252 14.6685 15.2435C14.6643 15.235 14.66 15.2265 14.656 15.218C14.513 14.932 14.348 14.601 14.283 14.276C14.197 13.847 14.279 13.45 14.528 13.063C14.774 12.681 15.105 12.472 15.479 12.365L17.829 7.66499C17.956 7.41099 18.216 7.25 18.5 7.25ZM18.5 9.677L19.786 12.25H17.213L18.5 9.677Z"
          fill="#0051FF"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C11.724 3 11.5 3.224 11.5 3.5C11.5 3.776 11.724 4 12 4C12.276 4 12.5 3.776 12.5 3.5C12.5 3.224 12.276 3 12 3ZM14.295 4.49199C14.427 4.18799 14.5 3.852 14.5 3.5C14.5 2.119 13.381 1 12 1C10.619 1 9.5 2.119 9.5 3.5C9.5 3.852 9.57298 4.18799 9.70498 4.49199C9.03498 4.78899 8.398 5.22101 7.823 5.78701C7.003 6.59301 6.023 7 5.048 7H4C3.448 7 3 7.448 3 8C3 8.552 3.448 9 4 9H5.048C6.6 9 8.07198 8.34899 9.22598 7.21299C9.76498 6.68199 10.371 6.32502 11 6.14302V21H9C8.448 21 8 21.448 8 22C8 22.552 8.448 23 9 23H15C15.552 23 16 22.552 16 22C16 21.448 15.552 21 15 21H13V6.14302C13.629 6.32502 14.235 6.68199 14.774 7.21299C15.928 8.34899 17.4 9 18.952 9H20C20.552 9 21 8.552 21 8C21 7.448 20.552 7 20 7H18.952C17.977 7 16.997 6.59301 16.177 5.78701C15.602 5.22101 14.965 4.78899 14.295 4.49199Z"
        fill="#0051FF"
      />
    </svg>
  );
};

export default ScaleIcon;
